// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2185":"963a9e5d","5129":"887d3231"}[chunkId] + ".chunk.css";
};